module.exports = __webpack_public_path__ + "img/full7-min.7059b638.png";